import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';

import {UIModule} from '../ui/ui.module';

import {OneTimeFeesComponent} from './one-time-fees/one-time-fees.component';
import {IncomesComponent} from './incomes/incomes.component';
import {ExpensesComponent} from './expenses/expenses.component';
import {JvUiModule} from '../../../../projects/jv-ui/src/lib/jv-ui.module';
import {GatewaysComponent} from './gateways/gateways.component';
import {BalancePopupComponent} from './gateways/balance-popup/balance-popup.component';
import { VoucherComponent } from './voucher/voucher.component';
import { AhaPointComponent } from './aha-point/aha-point.component';
import { PointPurchaseDetailComponent } from './aha-point/point-purchase-detail/point-purchase-detail.component';
import { PointUsedDetailComponent } from './aha-point/point-used-detail/point-used-detail.component';
import { PendingIesComponent } from './pending-ies/pending-ies.component';
import { PendingDetailComponent } from './pending-ies/pending-detail/pending-detail.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UIModule,
        JvUiModule
    ],
    declarations: [IncomesComponent, OneTimeFeesComponent, ExpensesComponent, GatewaysComponent, BalancePopupComponent, VoucherComponent, AhaPointComponent, PointPurchaseDetailComponent, PointUsedDetailComponent, PendingIesComponent, PendingDetailComponent],
    entryComponents: [BalancePopupComponent, PointPurchaseDetailComponent,PointUsedDetailComponent, PendingDetailComponent]
})
export class ControllersModule {
}
